import { render, staticRenderFns } from "./CountNewOrders.vue?vue&type=template&id=7668db08&"
import script from "./CountNewOrders.vue?vue&type=script&lang=js&"
export * from "./CountNewOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports